module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-header', {
    attrs: {
      "seller": _vm.seller
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tab border-1px"
  }, [_c('div', {
    staticClass: "tab-item"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "goods"
    }
  }, [_vm._v(_vm._s(_vm.$t("product")))])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "mymessage"
    }
  }, [_vm._v(_vm._s(_vm.$t("myinfo")))])], 1)]), _vm._v(" "), _c('keep-alive', [_c('router-view', {
    attrs: {
      "seller": _vm.seller
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c50af63c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 482
// module chunks = 1